import { useState, useEffect } from 'react'

interface AnimatedLogoProps {
  size?: 'sm' | 'md' | 'lg'
}

const AnimatedLogo = ({ size = 'md' }: AnimatedLogoProps) => {
  const [showExclamation, setShowExclamation] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      setShowExclamation((prev) => !prev)
    }, 2000)

    return () => clearInterval(interval)
  }, [])

  const sizeClasses = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-3xl',
  }

  const widthClasses = {
    sm: 'w-[0.5rem]',
    md: 'w-[0.6rem]',
    lg: 'w-[0.7rem]',
  }

  return (
    <div className="flex items-center">
      <span className={`${sizeClasses[size]} font-bold text-gradient`}>A</span>
      <span
        className={`${sizeClasses[size]} ${widthClasses[size]} font-bold text-gradient inline-flex justify-center transition-all duration-300 ease-in-out`}
        style={{
          transform: showExclamation ? 'scaleY(1.1)' : 'scaleY(1)',
        }}
      >
        {showExclamation ? '!' : 'I'}
      </span>
      <span className={`${sizeClasses[size]} font-bold text-foreground ml-1`}>Sym</span>
    </div>
  )
}

export default AnimatedLogo
